
export const Footer = (props) => {
  console.log(props.data)
  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
          
        </div>
      </div>
    </div>
  )
}
